import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";
// import { ResetPassword } from '../../api/api';
import { ResetPassword } from "../api/api";
import "./Verification.css";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import bgImage from "../../assets/images/brown-background.jpg";

const validationSchema = Yup.object().shape({
  code: Yup.string()
    .matches(/^\d{6}$/, "OTP must be a 6-digit number")
    .required("OTP is required"),
  password: Yup.string()
    .min(8, "Password must be at least 8 characters")
    .matches(/[a-z]/, "Password must contain a lowercase letter")
    .matches(/[A-Z]/, "Password must contain an uppercase letter")
    .matches(/\d/, "Password must contain a number")
    .matches(
      /[!@#$%^&*_]/,
      "Password must contain a special character (#?!@$%^&*_)"
    )
    .required("Password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm Password is required"),
});

const Verification = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { email } = location.state?.values || {};
  const [isLoading, setIsLoading] = useState(false);
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const [isConfirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

  const handleSubmit = async (formValues) => {
    try {
      setIsLoading(true);
      const response = await ResetPassword(formValues);
      if (response?.success === true) {
        alert(response.msg);
        navigate("/login");
      } else {
        alert(response?.msg || "Something went wrong");
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="verification-container"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="second-verification-container">
        <div className="header">
          <p>
            Enter the OTP sent to <strong className="highlight">{email}</strong>
          </p>
        </div>

        <Formik
          initialValues={{ code: "", password: "", confirmPassword: "", email }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({
            handleChange,
            handleBlur,
            handleSubmit,
            values,
            errors,
            touched,
          }) => (
            <form className="form" onSubmit={handleSubmit}>
              <input
                type="text"
                placeholder="Enter Email OTP"
                className="input"
                onChange={handleChange("code")}
                value={values.code}
              />
              {touched.code && errors.code && (
                <div className="error">{errors.code}</div>
              )}

              <div className="password-container">
                <input
                  type={isPasswordVisible ? "text" : "password"}
                  placeholder="Enter Password"
                  className="input"
                  onChange={handleChange("password")}
                  onBlur={handleBlur("password")}
                  value={values.password}
                />
                <span
                  onClick={() => setPasswordVisible(!isPasswordVisible)}
                  className="eye-icon"
                >
                  {isPasswordVisible ? (
                    <AiOutlineEye />
                  ) : (
                    <AiOutlineEyeInvisible />
                  )}
                </span>
              </div>
              {touched.password && errors.password && (
                <div className="error">{errors.password}</div>
              )}

              <div className="password-container">
                <input
                  type={isConfirmPasswordVisible ? "text" : "password"}
                  placeholder="Enter Confirm Password"
                  className="input"
                  onChange={handleChange("confirmPassword")}
                  onBlur={handleBlur("confirmPassword")}
                  value={values.confirmPassword}
                />
                <span
                  onClick={() =>
                    setConfirmPasswordVisible(!isConfirmPasswordVisible)
                  }
                  className="eye-icon"
                >
                  {isConfirmPasswordVisible ? (
                    <AiOutlineEye />
                  ) : (
                    <AiOutlineEyeInvisible />
                  )}
                </span>
              </div>
              {touched.confirmPassword && errors.confirmPassword && (
                <div className="error">{errors.confirmPassword}</div>
              )}

              <button
                type="submit"
                className="submit-button"
                disabled={isLoading}
              >
                {isLoading ? "Loading..." : "Continue"}
              </button>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default Verification;
